var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-loading',{ref:"app",attrs:{"id":"app","loading":_vm.loading}},[_c('transition',{attrs:{"name":"router"}},[(!_vm.loading)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }